module.exports = __webpack_public_path__ + "static/media/device.6ecea7ad.svg";